import entities from "./entities/de";
import pages from "./pages/de";
import globals from "./globals/de";
import formValidation from "./formValidation/de";
import enums from "./enums/de";

export default { entities, pages, globals, formValidation, enums };
